import { translation } from "@@/shared/translations/translation";
import { toObjectMap } from "@@/utilities/dictionary";
import { z } from "zod";

const blockContentSizes = ["S", "M", "L"] as const;
type BlockContentSize = (typeof blockContentSizes)[number];
const blockContentSize = toObjectMap<BlockContentSize>([...blockContentSizes]);

const blockContentSizeNames = {
    S: translation({
        sv: "Liten",
        en: "Small",
    }),
    M: translation({
        sv: "Medium",
        en: "Medium",
    }),
    L: translation({
        sv: "Stor",
        en: "Large",
    }),
};

const blockContentSizeZodSchema = z.enum(blockContentSizes);

export {
    blockContentSize,
    blockContentSizeNames,
    blockContentSizes,
    blockContentSizeZodSchema,
};
export type { BlockContentSize };
